// src/layouts/Layout.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import Navbar from "./Pages/Navbar/Navbar";
import BottomNav from "./Pages/Navbar/BottomNav";
import { isPublicSeoPath } from "./utils/seo";

const Layout = () => {
  const location = useLocation();

  // Use a regex to match exactly /counseling/chat/<number>
  const hideLayout = /^\/counseling\/chat\/\d+$/.test(location.pathname);

  return (
    <>
      {!isPublicSeoPath(location.pathname) && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      {!hideLayout && <Navbar />}
      <ScrollRestoration />
      <Outlet />
      {!hideLayout && <BottomNav />}
    </>
  );
};

export default Layout;
